// extracted by mini-css-extract-plugin
export default {"Container":"About_Container__0DsHG","Views":"About_Views__ua8PD","Bottom":"About_Bottom__4ITZc"};